import React, { useEffect, useState } from "react";

const ColourBorder = () => {
  const [degrees, setDegree] = useState(0);
  const [show, setShow] = useState(false);
  useEffect(() => {
    //So the Large Colour Fill does not flick onto the screen until the components have mounted
    setShow(true);
  }, []);

  useEffect(() => {
    var timer = setTimeout(() => {
      if (degrees < 4500) {
        setDegree(degrees + 2);
      }
    }, 80);
    return () => {
      clearTimeout(timer);
    };
  }, [degrees]);

  if (show) {
    return (
      <div
        className="colour-border"
        style={{
          background:
            "conic-gradient(from " +
            degrees +
            "deg at 49.81% 49.42%, #00a799 0deg, #023a4a 91.09deg, #00a799 180.58deg, #023a4a 271.56deg, #00a799 360deg)",
        }}
      >
        <div className="colour-border-white"></div>
      </div>
    );
  }
  return null;
};

export default ColourBorder;
